/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Preset_LabelInputs */



/**
* | output |
* | --- |
* | "Mix Preset" |
*
* @param {Audio_Description_Export_Automix_Preset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_preset_label = /** @type {((inputs?: Audio_Description_Export_Automix_Preset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Preset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préréglage de mix")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mix-Voreinstellung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preimpostazione di mixaggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный микс")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preajuste de mezcla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("混合预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ミックスプリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिक्स प्रीसेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mix Preset")
	return /** @type {LocalizedString} */ ("Mix Preset")
});